// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Avatar_imageWrapper__fpNSQ","placeholder":"Avatar_placeholder__aB7Go","placeholderDefault":"Avatar_placeholderDefault__jGOf2"};